import React, { useState, useEffect } from 'react';
import AddFeedbackModal from './AddFeedbackModal';
import FeedbackItem from './FeedbackItem';
import './FeedbackPage.css';

function FeedbackPage({ user, isAdmin }) {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('error');
  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    fetchFeedback();
  }, []);

  const fetchFeedback = async () => {
    try {
      setLoading(true);
      const response = await fetch('/backend/api/feedback/list.php', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setFeedback(data.feedback);
        }
      }
    } catch (error) {
      console.error('Error fetching feedback:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddFeedback = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };

  const handleFeedbackSubmitted = () => {
    setShowAddModal(false);
    fetchFeedback(); // Refresh the list
  };

  const handleStatusUpdate = () => {
    fetchFeedback(); // Refresh after status update
  };

  // Filter feedback by active tab
  const filteredFeedback = feedback.filter(item => item.type === activeTab);

  return (
    <div className="feedback-page">
      <div className="page-header">
        <div className="header-left">
          <div className="tabs">
            <button 
              className={`tab ${activeTab === 'error' ? 'active' : ''}`}
              onClick={() => setActiveTab('error')}
            >
              Errors ({feedback.filter(f => f.type === 'error').length})
            </button>
            <button 
              className={`tab ${activeTab === 'idea' ? 'active' : ''}`}
              onClick={() => setActiveTab('idea')}
            >
              Ideas ({feedback.filter(f => f.type === 'idea').length})
            </button>
          </div>
        </div>
        
        <div className="header-right">
          <button className="btn-primary" onClick={handleAddFeedback}>
            Add Feedback
          </button>
        </div>
      </div>

      <div className="feedback-content">
        {loading ? (
          <div className="loading">Loading feedback...</div>
        ) : filteredFeedback.length === 0 ? (
          <div className="empty-state">
            <p>No {activeTab}s submitted yet.</p>
            <p>Be the first to share your feedback!</p>
          </div>
        ) : (
          <div className="feedback-list">
            {filteredFeedback.map(item => (
              <FeedbackItem
                key={item.id}
                feedback={item}
                isAdmin={isAdmin}
                onStatusUpdate={handleStatusUpdate}
              />
            ))}
          </div>
        )}
      </div>

      {showAddModal && (
        <AddFeedbackModal
          isOpen={showAddModal}
          onClose={handleCloseAddModal}
          onSuccess={handleFeedbackSubmitted}
        />
      )}
    </div>
  );
}

export default FeedbackPage;
